/** Shared formatting helpers for the activity timeline. */

export function formatDuration(ms: number): string {
  if (ms <= 0) return "0ms";
  if (ms < 1000) return `${ms}ms`;
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(1)}s`;
  const m = Math.floor(s / 60);
  const rem = Math.round(s - m * 60);
  return `${m}m ${rem}s`;
}

/** Middle-less left-ellipsis for a long cwd, keeping the tail visible. */
export function shortPath(p: string, max = 48): string {
  if (p.length <= max) return p;
  return `…${p.slice(p.length - (max - 1))}`;
}
